import axios from 'axios'
import { currentConfig } from '../../config/env.js'

// 创建axios实例
const instance = axios.create({
    baseURL: currentConfig.baseURL, // 使用环境配置中的baseURL
    timeout: currentConfig.timeout, // 使用环境配置中的timeout
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
})

// 请求拦截器
instance.interceptors.request.use(
    (config) => {
        // 在发送请求之前做些什么
        return config
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 响应拦截器
instance.interceptors.response.use(
    (response) => {
        // 对响应数据做点什么
        return response.data
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 封装request函数
const request = (options) => {
    const { url, method = 'GET', data, params, headers = {} } = options

    return instance({
        url,
        method: method.toUpperCase(),
        data,
        params,
        headers
    })
}

// 导出常用的请求方法
export const get = (url, params, config = {}) => {
    return instance.get(url, { params, ...config })
}

export const post = (url, data, config = {}) => {
    return instance.post(url, data, config)
}

export const put = (url, data, config = {}) => {
    return instance.put(url, data, config)
}

export const del = (url, config = {}) => {
    return instance.delete(url, config)
}

export default request 